import { IDataConnectionInfo } from '~src/datasource/dataConnection/models/IDataConnectionInfo';

import { FlowAnalyticsExtensionConnection } from '../serverApi/types/FlowAnalyticsExtensionConnection';

export interface FlowAnalyticsExtensionRow extends IDataConnectionInfo {
  contentType: 'dataconnection';
  analyticsExtensionConnection: FlowAnalyticsExtensionConnection;
  analyticsExtensionFlowLuid: string;
}

export function isFlowAnalyticsExtensionRow(item: unknown): item is FlowAnalyticsExtensionRow {
  const row = item as Partial<FlowAnalyticsExtensionRow>;
  return !!row && row.contentType === 'dataconnection' && !!row.analyticsExtensionConnection;
}
